/* Cart discount form (page + drawer share this file — same data-* hooks in both
 * snippets/afroyla-cart-discount-form.liquid instances). Ported from the Broadcast
 * store's assets/afroyla-cart-discount.js.
 *
 * Mechanics, all measured on the store:
 * - GET /discount/CODE appends the code to the session; it evicts nothing.
 * - POST /cart/update.js {discount: 'A,B'} replaces the attached set with exactly those
 *   codes; '' clears every code. This is how one chip's × can remove one code and leave
 *   the rest.
 * - cart.discount_codes lists every attached code even on an empty cart; applicable:false
 *   covers both dead codes and codes with nothing entitled.
 *
 * afroyla-coupon-strip.js (PDP) listens for the two events dispatched here —
 * afroyla:discount:applied / :removed — so its claimed-flag memory follows what the
 * shopper actually did on the cart. `theme:cart:refresh` is Horizon's own bridge (see
 * afroyla-theme-events.js): it re-dispatches `shopify:cart:lines-update`, which
 * `cart-items-component` answers with a real Section Rendering fetch — the fresh totals,
 * chips and struck prices come back from the server, not from any DOM patch this file
 * writes itself. */
(function () {
  'use strict';

  if (window.__aflCartDiscountInit) return;
  window.__aflCartDiscountInit = true;

  var SCOPE = '.afl-cart-discount';
  var APPLY = '[data-apply-discount]';
  var REMOVE = '[data-remove-discount]';
  var INPUT = '[data-discount-input]';
  var TAGS = '[data-discount-tags]';
  var TAG_TEMPLATE = '[data-discount-tag-template]';
  var ERROR = '[data-discount-error-message]';

  var busy = false;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function attachedCodes(cart) {
    var out = [];
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].code) out.push(codes[i]);
    }
    return out;
  }

  function writeSet(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
  }

  function sameCode(a, b) {
    return typeof a === 'string' && typeof b === 'string' && a.toLowerCase() === b.toLowerCase();
  }

  function showError(message) {
    var els = document.querySelectorAll(ERROR);
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = message;
      els[i].classList.toggle('hidden', !message);
    }
  }

  function setBusy(on) {
    busy = on;
    var buttons = document.querySelectorAll(APPLY);
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = on;
      buttons[i].setAttribute('aria-busy', on ? 'true' : 'false');
    }
  }

  /* Chips mirror the server's own rule: a chip per applicable code. A dead or
   * not-yet-applicable code stays attached but earns no chip — same as the Liquid
   * render in afroyla-cart-discount-form.liquid, so navigation never changes what the
   * shopper sees. */
  function renderChips(cart) {
    var containers = document.querySelectorAll(TAGS);
    var template = document.querySelector(TAG_TEMPLATE);
    var codes = attachedCodes(cart).filter(function (entry) {
      return entry.applicable !== false;
    });

    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      container.innerHTML = '';
      for (var j = 0; j < codes.length; j++) {
        var tag = null;
        if (template && template.content && template.content.firstElementChild) {
          tag = template.content.firstElementChild.cloneNode(true);
        }
        if (!tag) continue;
        tag.setAttribute('data-discount-code', codes[j].code);
        var text = tag.querySelector('[data-discount-tag-text]');
        if (text) text.textContent = codes[j].code;
        container.appendChild(tag);
      }
      container.classList.toggle('is-empty', codes.length === 0);
    }
  }

  function announce(name, code) {
    document.dispatchEvent(new CustomEvent(name, { detail: { code: code } }));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
  }

  function applyCode(code) {
    if (busy) return;
    setBusy(true);
    showError('');

    fetchCart()
      .then(function (cart) {
        if (!cart) throw new Error('cart unreachable');
        var current = attachedCodes(cart);
        for (var i = 0; i < current.length; i++) {
          if (sameCode(current[i].code, code)) throw new Error('already');
        }
        var set = current.map(function (entry) {
          return entry.code;
        });
        set.push(code);
        return writeSet(set).then(fetchCart).then(function (fresh) {
          if (!fresh) throw new Error('cart unreachable');
          var entry = null;
          var now = attachedCodes(fresh);
          for (var j = 0; j < now.length; j++) {
            if (sameCode(now[j].code, code)) entry = now[j];
          }
          // With items in the cart, "attached but not applicable" means the shopper
          // gets nothing at checkout — put the set back and say so rather than leaving
          // a chip that pays out $0.
          if (!entry || (fresh.item_count > 0 && entry.applicable === false)) {
            // Shopify keeps whichever discount is worth more to the shopper (help: discount-combinations).
            // When a gated set price (cart attribute _afl_lp) is on the cart, that is why the code lost — say so.
            var setBeats = !!(fresh.attributes && fresh.attributes._afl_lp);
            return writeSet(set.slice(0, -1)).then(function () {
              throw new Error(setBeats ? 'set beats code' : 'not applicable');
            });
          }
          var inputs = document.querySelectorAll(INPUT);
          for (var k = 0; k < inputs.length; k++) inputs[k].value = '';
          renderChips(fresh);
          announce('afroyla:discount:applied', entry.code);
          // A gated set price (cart attribute _afl_lp) and a store code cannot combine; Shopify keeps whichever is
          // worth more for the whole cart. If the code won, the set's allocations are gone — say so plainly so the
          // shopper knows why the free pieces are now priced (owner 10.09: "show, don't hide").
          if (fresh.attributes && fresh.attributes._afl_lp) {
            var setStillOn = false;
            for (var q = 0; q < fresh.items.length; q++) {
              var allocs = fresh.items[q].line_level_discount_allocations || [];
              for (var w = 0; w < allocs.length; w++) {
                var ttl = (allocs[w].discount_application && allocs[w].discount_application.title) || '';
                if (ttl && !sameCode(ttl, entry.code)) setStillOn = true;
              }
            }
            if (!setStillOn) {
              // the drawer re-renders on the refresh event right after this — write the notice again once it has settled
              var notice = 'Your code saves more than the set price, so it replaced the set — the pieces are priced by the code now.';
              showError(notice);
              setTimeout(function () { showError(notice); }, 1500);
              setTimeout(function () { showError(notice); }, 3000);
            }
          }
        });
      })
      .catch(function (err) {
        if (err && err.message === 'already') {
          showError('That code is already on your order');
        } else if (err && err.message === 'set beats code') {
          showError('Your set price is already the better deal, so this code was not applied');
        } else if (err && err.message === 'not applicable') {
          showError('That code did not apply to this order');
        } else {
          showError('Could not apply the code — try again');
        }
      })
      .then(function () {
        setBusy(false);
      });
  }

  function removeCode(code) {
    if (busy) return;
    setBusy(true);
    showError('');

    fetchCart()
      .then(function (cart) {
        if (!cart) throw new Error('cart unreachable');
        var rest = attachedCodes(cart)
          .filter(function (entry) {
            return !sameCode(entry.code, code);
          })
          .map(function (entry) {
            return entry.code;
          });
        return writeSet(rest).then(fetchCart).then(function (fresh) {
          if (!fresh) throw new Error('cart unreachable');
          renderChips(fresh);
          announce('afroyla:discount:removed', code);
        });
      })
      .catch(function () {
        showError('Could not remove the code — try again');
      })
      .then(function () {
        setBusy(false);
      });
  }

  document.addEventListener('click', function (event) {
    var applyBtn = event.target.closest && event.target.closest(APPLY);
    if (applyBtn) {
      event.preventDefault();
      var scope = applyBtn.closest(SCOPE) || document;
      var input = scope.querySelector(INPUT) || document.querySelector(INPUT);
      var code = input ? input.value.trim() : '';
      if (code) applyCode(code);
      return;
    }

    var removeBtn = event.target.closest && event.target.closest(REMOVE);
    if (removeBtn) {
      event.preventDefault();
      var chip = removeBtn.closest('[data-discount-body]');
      var code = ((chip && chip.getAttribute('data-discount-code')) || '').trim();
      if (code) removeCode(code);
    }
  });

  // Enter inside the code field applies, and never submits a surrounding form.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest(INPUT);
    if (!input) return;
    event.preventDefault();
    var code = input.value.trim();
    if (code) applyCode(code);
  });
})();
